import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

class Username extends Component {
  render(){
    const { classes, theme, location, data } = this.props;
    return(
      <Typography type="subheading" className={classes.root}>
        ID: {data.username}
      </Typography>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Username);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/User/scenes/Core/components/Username/index.js